"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// See https://marked.js.org/#/USING_ADVANCED.md#options for full list of setOptions
var classNames = require("classnames");

var marked = require('marked');

marked.setOptions({
  renderer: new marked.Renderer(),
  smartLists: true
});

function createHtml(html) {
  return {
    __html: html
  };
}

function MarkdownViewer(_ref) {
  var markdown = _ref.markdown,
      _ref$replaceSymbols = _ref.replaceSymbols,
      replaceSymbols = _ref$replaceSymbols === void 0 ? true : _ref$replaceSymbols,
      priority = _ref.priority,
      className = _ref.className,
      style = _ref.style;

  // For <h> tags
  if (priority) {
    var CustomTag = "h".concat(priority);
    return /*#__PURE__*/_react["default"].createElement(CustomTag, {
      className: className
    }, markdown);
  }

  var viewerClasses = classNames("marked", className, {});

  if (!markdown) {
    console.warn("No 'markdown' received by MarkdownViewer.");
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: style,
    className: viewerClasses,
    dangerouslySetInnerHTML: createHtml(marked(replaceSymbols ? removeSymbols(markdown) : markdown))
  });
}

MarkdownViewer.propTypes = {
  className: _propTypes["default"].string,
  markdown: _propTypes["default"].string.isRequired,
  replaceSymbols: _propTypes["default"].bool,
  priority: _propTypes["default"].string,
  style: _propTypes["default"].object
};
var _default = MarkdownViewer; // Helper functions

exports["default"] = _default;

function removeSymbols(str) {
  str = str.replace(/[™®©]/g, '<sup>$&</sup>');
  var title = str.match(/title='(.*?)'/ig);

  if (title) {
    var newStr = str;

    for (var i = 0; i < title.length; i++) {
      var newTitle = title[i].replace("<sup>", "").replace("</sup>", "");
      newStr = newStr.replace(title[i], newTitle);
    }

    return newStr;
  } else {
    return str;
  }
}

//# sourceMappingURL=MarkdownViewer.js.map